import { apiRequest } from "../../../shared/api/client";
import type {
  ImportBatch,
  ImportBatchInput,
  Shop,
  ShopCreateInput,
  ShopRepository,
  ShopUpdateInput
} from "../types";

/** ShopRepository backed by the Fastify + Postgres API. */
export const apiShopRepository: ShopRepository = {
  listShops() {
    return apiRequest<Shop[]>("/shops");
  },

  listImportBatches() {
    return apiRequest<ImportBatch[]>("/import-batches");
  },

  createShop(input: ShopCreateInput) {
    return apiRequest<Shop>("/shops", {
      method: "POST",
      body: JSON.stringify(input)
    });
  },

  updateShop(id: string, input: ShopUpdateInput) {
    return apiRequest<Shop>(`/shops/${id}`, {
      method: "PATCH",
      body: JSON.stringify(input)
    });
  },

  async deleteShop(id: string) {
    await apiRequest<void>(`/shops/${id}`, { method: "DELETE" });
  },

  importShops(shops: ShopCreateInput[], batch: ImportBatchInput) {
    return apiRequest<ImportBatch>("/import", {
      method: "POST",
      body: JSON.stringify({ shops, batch })
    });
  }
};
